module.exports = __webpack_public_path__ + "static/media/img_10.a1aae654.png";